import React from 'react';
import { Button } from 'react-bootstrap';
import useNumericForecastCP from 'utils/hooks/meteorology/useNumericForecastControlPanel';

export default function RegionButton({ text, value }: { text: string, value: string }) {
  const { setRegion, region } = useNumericForecastCP();

  const activeStyle = region === value ? 'btn-control-panel-active' : '';

  return (
    <Button variant="link" onClick={() => setRegion(value)} className={`btn-control-panel ${activeStyle}`}>
      { text }
    </Button>
  );
}
